import './styles.css';
export var styledOrText = '_1bfp49g0-3-12-1';